import Glide from "@glidejs/glide";
import { Squares2X2Icon } from "@heroicons/react/24/outline";
import { Tab, Tabs } from "@mui/material";
import AlertModalMessage from "components/AlertModal/AlertModalMessage";
import ContactModal from "components/AlertModal/ContactModal";
import CommentListing from "components/CommentListing/CommentListing";
import FormItem from "components/FormItem/FormItem";
import LikeSaveBtns from "components/LikeSaveBtns";
import BookingLoader from "components/Loader/BookingLoader";
import DetailLoader from "components/Loader/DetailLoader";
import LoginModal from "components/LoginModal/LoginModal";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import NcInputNumberOne from "components/NcInputNumber/NcInputNumberOne";
import SocialMediaShare from "components/SocialMediaShare/SocialMediaShare";
import StartRating from "components/StartRating/StartRating";
import { AuthContext } from "context/appContext";
import { motion } from "framer-motion";
import { useAppDispatch, useAppSelector, useScrollToHash, useSingleInView } from "hooks/hooks";
import Cookies from "js-cookie";
import { Clock, Users } from "lucide-react";
import React, { FC, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet";
import { FaHome } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getOwnerById } from "redux/features/auth/authSlice";
import { createConversation } from "redux/features/conversation/conversationSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  addToFavoris,
  checkFavoriByClientId,
  deleteLocationFromFavoris,
  fetchCommentById,
  fetchLocationById,
  fetchPriceById,
  getFavorisByClient,
  getSimilarLocations,
  initStates,
} from "redux/features/locations/locationSlice";
import {
  checkReservation,
  fetchAvailableHours,
  fetchfullyDays,
  payReservation,
} from "redux/features/reservations/reservationSlice";
import { fetchUnavailableByLocation } from "redux/features/unavailable/unavailableSlice";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import CheckboxInput from "shared/Checkbox/CheckboxInput";
import NcImage from "shared/NcImage/NcImage";
import Select from "shared/Select/Select";
import TextDisplay from "utils/textAreaDisplay";
import MobileFooterSticky from "../(components)/MobileFooterSticky";
import DetailPagetLayout from "../Layout";
import StayDatesRangeInput from "./StayDatesRangeInput";

const ListingStayDetailPage: FC<{}> = () => {
  let locationState = useAppSelector((state) => state.featureLocation.locationDetail);
  let fullyDaysState = useAppSelector((state) => state.featureReservation.fullyDays);
  let unavailableState = useAppSelector((state) => state.featureUnvailable.unavailables);
  let ownerState = useAppSelector((state) => state.auth.owner);
  let commentStates = useAppSelector((state) => state.featureLocation.locationDetail?.comments);

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const dispatch = useAppDispatch();
  const router = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const profilId = authContext?.user?.profil?.id;
  const [selectedDay, setSelectedDay] = useState<Date | null>(null);
  const [showAllComments, setShowAllComments] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [hours, setHours] = useState<number[]>([]);
  const [price, setPrice] = useState<any>(null);
  const [priceStartHour, setPriceStartHour] = useState<any>("");
  const [priceEndHour, setPriceEndHour] = useState<any>("");
  const [priceId, setPriceId] = useState<string>("");
  const [periode, setPeriode] = useState<number>(parseInt(locationState?.nbreHour?.toString(), 10) ?? 0);
  const [halfTotal, setHalfTotal] = useState<number>(0);
  const [tva, setTva] = useState<number>(0);
  const [extraTotal, setExtraTotal] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [reservation, setReservation] = useState<any>(null);
  const [services, setServices] = useState<number>(0);

  const [availableHoursState, setAvailableHoursState] = useState<{ start: number; durations: number[] }[]>([]);
  const [selectedStartHour, setSelectedStartHour] = useState<any | null>(null);
  const [selectedEndHour, setSelectedEndHour] = useState<any | null>(null);
  const [selectedDuration, setSelectedDuration] = useState<number | null>(null);

  const [selectedEvent, setSelectedEvent] = useState<string | null>("");
  const [maxDuration, setMaxDuration] = useState<number>(0);
  const [Submit, setSubmit] = useState<boolean>(false);
  const [allDescs, setAllDesc] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModalExistReservation, setShowModalExistReservation] = useState(false);
  const [showSocialMediaShare, setShowSocialMediaShare] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [visitorRange, setVisitorRange] = useState<string | undefined>(undefined);
  const [isCleaningCosts, setIsCleaningCosts] = useState(false);
  const states = useAppSelector((state) => state.featureLocation);
  const [availableDays, setAvailableDays] = useState<string[]>(locationState?.availableDays || []);

  const acceptedCookies = Cookies.getJSON("eventtobee");
  const [cookies, setCookie] = useCookies(["visitedLocations"]);
  const [checkedExtra, setCheckedExtra] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(locationState?.minPriceType);
  const [contact, setContact] = useState(false);
  const lat = 48.8584;
  const lng = 2.2945;

  const { ref: commentsRef, inView: commentsInView } = useSingleInView();
  const { ref: ownerRef, inView: ownerInView } = useSingleInView();
  const formItemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
  };

  useEffect(() => {
    if (locationState?.prices && value) {
      const filteredDays = Array.from(
        new Set(
          locationState.prices
            .filter((price: any) => price.type === value && price.enable)
            .map((price: any) => price.day)
        )
      );
      setAvailableDays(filteredDays);
    } else {
      setAvailableDays(locationState?.availableDays || []);
    }
  }, [value, locationState?.prices, locationState?.availableDays]);

  const [location_minPrice, setLocation_MinPrice] = useState<number | null>(null);

  useEffect(() => {
    const prices_list = locationState.prices;
    let minPrice: number | null = null;

    if (value === "journée complète") {
      const journeePrices = prices_list
        .filter((price: any) => price.type === "journée complète")
        .map((price) => price.price);
      minPrice = journeePrices.length > 0 ? Math.min(...journeePrices) : null;
    } else if (value === "heure") {
      const heurePrices = prices_list.filter((price: any) => price.type === "heure").map((price) => price.price);
      minPrice = heurePrices.length > 0 ? Math.min(...heurePrices) : null;
    } else if (value === "soirée") {
      const soireePrices = prices_list.filter((price: any) => price.type === "soirée").map((price) => price.price);
      minPrice = soireePrices.length > 0 ? Math.min(...soireePrices) : null;
    } else if (value === "demi-journée") {
      const demiJourneePrices = prices_list
        .filter((price: any) => price.type === "demi-journée")
        .map((price) => price.price);
      minPrice = demiJourneePrices.length > 0 ? Math.min(...demiJourneePrices) : null;
    }

    setLocation_MinPrice(minPrice);
  }, [value, locationState.prices]);

  const isLiked = useAppSelector((state) => {
    const likedLocation = state?.featureLocation.likedLocation || [];
    const locationId = id;
    if (Array.isArray(likedLocation) && likedLocation.length > 0 && locationId) {
      const foundItem = likedLocation.find((item: any) => item.locationId === locationId);
      return !!foundItem;
    }
    return true;
  });

  useEffect(() => {
    const parsedValue = parseInt(locationState?.nbreHour?.toString(), 10);
    if (!isNaN(parsedValue)) {
      setPeriode(parsedValue);
    }
  }, [locationState?.nbreHour]);

  const [formData, setFormData] = useState({
    selectedDate: selectedDay,
    reservation_unit: value,
    startHour: selectedStartHour ? String(selectedStartHour + ":00") : priceStartHour,
    endHour: selectedStartHour ? String(Number(selectedStartHour + periode) + ":00") : priceEndHour,
    validation: false,
    visitor: locationState.visitor,
    locationId: locationState?.id,
    ownerId: locationState?.Client?.id,
    price: total,
    tva: tva,
    halfTotal: halfTotal,
    extra: extraTotal,
    service: services,
    menagementPrice: isCleaningCosts ? locationState.cleaning_costs : 0,
  });

  const googleMapsURL = `https://www.google.com/maps/embed/v1/place?key=${
    process.env.REACT_APP_MAPS_API_KEY
  }&q=${Number(lat)},${Number(lng)}`;

  useEffect(() => {
    dispatch(initStates());
    if (id && profilId) {
      dispatch(checkFavoriByClientId({ locationId: id, clientId: profilId }));
    }
  }, [id, profilId, dispatch]);

  useEffect(() => {
    if (profilId) {
      dispatch(getFavorisByClient({ clientId: profilId }));
    }
  }, [profilId]);

  useEffect(() => {
    if (acceptedCookies === "accepted") {
      const visitedLocations = cookies.visitedLocations || [];

      const isVisited = visitedLocations.includes(id);

      if (!isVisited) {
        const updatedVisitedLocations = [...visitedLocations, id];
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 30);
        setCookie("visitedLocations", updatedVisitedLocations, { path: "/", expires: expirationDate });
      }
    }
  }, [id, cookies.visitedLocations, setCookie]);

  useEffect(() => {
    if (id && locationState?.CategoryLocation?.id) {
      dispatch(getSimilarLocations({ locationId: parseInt(id), categoryId: locationState.CategoryLocation.id }));
    }
  }, [id, locationState?.CategoryLocation?.id, dispatch]);

  const glideRef = useRef(null);
  const relatedLocations = useAppSelector((state) => state.featureLocation.similarLocations);

  useEffect(() => {
    if (relatedLocations && glideRef.current) {
      const glide = new Glide(glideRef.current, {
        type: "carousel",
        perView: 4,
        gap: 20,
        autoplay: 1500,
      });

      glide?.mount();
      return () => glide?.destroy();
    }
  }, [relatedLocations]);

  useEffect(() => {
    setValue(locationState?.minPriceType);
  }, [locationState?.minPriceType]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (id) {
          const res = await dispatch(fetchLocationById(id));
          if (res.payload.validation !== "approuvé" && profilId !== res.payload.userId) {
            navigate("/espace-evenementiel");
            return;
          } else {
            await dispatch(fetchUnavailableByLocation(id));
          }
        }
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    fetchData();
    return () => {
      setReservation(null);
    };
  }, [id, profilId, dispatch, navigate]);

  useEffect(() => {
    if (locationState?.minStartHour && locationState?.maxEndHour) {
      const startHour = parseInt(locationState.minStartHour);
      const endHour = parseInt(locationState.maxEndHour);
      const updatedHour = generateHoursArray(startHour, endHour);
      setHours(updatedHour);
    }
  }, [locationState?.minStartHour, locationState?.maxEndHour]);

  useEffect(() => {
    const total = checkedExtra.reduce(
      (acc, checkedItem) => (checkedItem.isChecked ? acc + checkedItem.price * checkedItem.qte : acc),
      0
    );
    setExtraTotal(total);
  }, [checkedExtra]);

  useEffect(() => {
    if (periode) {
      handleTotalChange(periode);
    }
  }, [extraTotal, periode, price, selectedEvent, selectedDay]);

  useEffect(() => {
    setFormData({
      selectedDate: selectedDay,
      reservation_unit: value,
      startHour: value === "heure" ? (selectedStartHour ? `${selectedStartHour}:00` : "") : priceStartHour,

      endHour:
        value === "heure" ? (selectedStartHour ? `${Number(selectedStartHour) + periode}:00` : "") : priceEndHour,

      validation: false,
      visitor: locationState.visitor,
      locationId: locationState?.id,
      ownerId: locationState?.userId,
      price: total,
      halfTotal: halfTotal,
      tva: tva,
      extra: extraTotal,
      service: services,
      menagementPrice: isCleaningCosts ? locationState.cleaning_costs : 0,
    });
  }, [total, selectedDay, selectedStartHour]);

  const handleClickLike = useCallback(async () => {
    if (!profilId) {
      setShowLoginModal(true);
      return;
    }
    if (id && states.likedLocation) {
      if (isLiked) {
        await dispatch(addToFavoris({ locationId: id, clientId: profilId }));
      } else {
        await dispatch(deleteLocationFromFavoris({ locationId: id, clientId: profilId }));
      }
      await dispatch(getFavorisByClient({ clientId: profilId }));
    }
  }, [profilId, id, isLiked, states.likedLocation, dispatch]);

  const generateHoursArray = (startHour: any, endHour: any) => {
    const updatedHour = [];
    for (let i = startHour; i <= endHour; i++) {
      updatedHour.push(i);
    }
    return updatedHour;
  };

  const handleShareButtonClick = () => {
    setShowSocialMediaShare(!showSocialMediaShare);
  };

  const handleChangeData = (itemIdentifier: any, value: any) => {
    setCheckedExtra((prevCheckedExtra) => {
      const updatedArray = [...prevCheckedExtra];
      const targetIndex = updatedArray.findIndex(
        (x) =>
          x.designation === itemIdentifier.designation &&
          x.price === itemIdentifier.price &&
          x.priceId === itemIdentifier.priceId
      );

      if (targetIndex !== -1) {
        updatedArray[targetIndex] = {
          ...updatedArray[targetIndex],
          qte: value,
        };
      }

      return updatedArray;
    });
  };

  const [selectedPriceId, setSelectedPriceId] = useState("");
  const handleChangePrice = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    let res;
    const selectedPriceId = event.target.value;
    setSelectedPriceId(selectedPriceId);
    setPriceId(selectedPriceId);

    res = (await dispatch(fetchPriceById(event.target.value))) as {
      payload: {
        price: number;
        priceId: string;
        min: string;
        max: string;
        type: string;
        startHour: string;
        endHour: string;
      };
    };

    if (res.payload) {
      setPrice(res.payload.price);
      setPriceStartHour(res.payload.startHour);
      setPriceEndHour(res.payload.endHour);
      setPriceId(res.payload.priceId);
      setVisitorRange(`${res.payload.min} - ${res.payload.max}`);
    }
  };

  const handleExtraCheckboxChange = (item: any, isChecked: boolean) => {
    if (!item) return;

    setCheckedExtra((prevCheckedExtra) => {
      const index = prevCheckedExtra.findIndex(
        (x) => x.designation === item.designation && x.price === item.price && x.priceId === item.priceId
      );

      if (index === -1 && isChecked) {
        return [...prevCheckedExtra, { ...item, isChecked: true, qte: 1 }];
      }

      if (index !== -1) {
        const updated = [...prevCheckedExtra];
        if (isChecked) {
          updated[index] = { ...updated[index], isChecked: true };
        } else {
          updated.splice(index, 1); // supprime l’item décoché
        }
        return updated;
      }

      return prevCheckedExtra;
    });
  };
  const [showLastMinuteWarning, setShowLastMinuteWarning] = useState(false);
  const [isConfirmedLastMinute, setIsConfirmedLastMinute] = useState(false);
  const handleSubmit = async () => {
    setIsLoadingSubmit(true);

    if (!profilId || authContext.user?.role !== "client") {
      if (setShowLoginModal) {
        setShowLoginModal(true);
        setIsLoadingSubmit(false);
        return;
      }
    }

    const selectedDate = formData.selectedDate;
    if (selectedDate) {
      const now = new Date();
      const diff = selectedDate && selectedDate?.getTime() - now.getTime();
      const isInPast = selectedDate && diff < 0;
      const isLessThan48h = selectedDate && diff < 48 * 60 * 60 * 1000 && diff > 0;
      if (isInPast) {
        // Already handled by button disabling, but you can double-protect here
        setIsLoadingSubmit(false);
        return;
      }

      if (isLessThan48h && !isConfirmedLastMinute) {
        setShowLastMinuteWarning(true);
        setIsLoadingSubmit(false);
        return;
      }
    }

    // Proceed with normal flow
    const check = await dispatch(checkReservation(formData));

    if (check.payload.error) {
      setShowModalExistReservation(true);
      setIsLoadingSubmit(false);
    } else {
      const res = await dispatch(
        payReservation({
          quantity: periode,
          priceId,
          location: id,
          extra: checkedExtra,
          reservation: formData,
          visitor: visitorRange,
          commission: locationState?.commission,
        })
      );
      window.location.href = res.payload;
    }
  };

  const handleContact = async () => {
    if (!profilId || authContext.user?.role !== "client") {
      if (setShowLoginModal) {
        setShowLoginModal(true);
        setIsLoadingSubmit(false);
        return;
      }
    } else {
      setContact(true);
    }
  };
  useEffect(() => {
    if (selectedStartHour === null) {
      setMaxDuration(parseInt(locationState?.nbreHour || "1"));
      return;
    }

    // 1) On trouve l’objet slot pour l’heure choisie
    const slot = availableHoursState.find((s) => s.start === selectedStartHour);
    if (!slot) {
      // si aucun créneau, on met le minimum
      setMaxDuration(parseInt(locationState?.nbreHour || "1"));
      return;
    }

    // 2) La durée maximale ‘brute’ est la dernière entrée de slot.durations
    const rawMax = slot.durations[slot.durations.length - 1];
    // 3) On s’assure qu’on ne soit pas en dessous du min
    const minH = parseInt(locationState?.nbreHour || "1");
    setMaxDuration(Math.max(rawMax, minH));
  }, [selectedStartHour, availableHoursState, locationState?.nbreHour]);
  const handleSelectedDayChange = async (day: Date) => {
    setSelectedDay(day);
    setSelectedStartHour(null);
    setMaxDuration(0);
    if (value === "heure") {
      setPeriode(parseInt(locationState?.nbreHour));
    } else {
      setPeriode(1);
    }

    if (day) {
      setSubmit(true);
      //await dispatch(fetchAvailableHours({ id, selectedDay: day, type: value }));
      (async () => {
        try {
          // On dispatche le thunk et on “unwrap” pour récupérer directement le payload
          const actionResult = await dispatch(fetchAvailableHours({ id, selectedDay: day, type: value }));
          const slots = unwrapResult(actionResult);
          // slots est un HourSlot[] si tout s’est bien passé
          setAvailableHoursState(slots);
        } catch (err) {
          console.error("Impossible de charger les créneaux :", err);
          setAvailableHoursState([]);
        }
      })();

      setSubmit(false);
    }
  };

  useEffect(() => {
    setSelectedStartHour(null);
    setSelectedEndHour(null);
    setPriceEndHour(null);
    setPriceStartHour(null);
    setSelectedHourRange("");
    setSelectedEvent("");
    setTotal(0);
    setServices(0);
    setHalfTotal(0);
  }, [selectedDay]);

  useEffect(() => {
    setAvailableHoursState([]);
    setSelectedDay(null);
    setSelectedStartHour(null);
    setSelectedEndHour(null);
    setTotal(0);
    setServices(0);
    setHalfTotal(0);
  }, [value]);

  const handleAvailibility = async () => {
    dispatch(fetchfullyDays({ id: id, type: value }));
  };
  const handleTotalChange = (hour: number) => {
    let cleaning_costs;
    let isValid = false;

    if (selectedEvent) {
      isValid = locationState?.cleaning_costs_events?.some((event: any) => event.trim() === selectedEvent.trim());
      setIsCleaningCosts(isValid);
    }

    if (isValid) {
      cleaning_costs = locationState.cleaning_costs || 0;
    } else {
      cleaning_costs = 0;
    }
    if (hour !== null && locationState !== undefined) {
      const firstPrice = hour * Number(price);

      setHalfTotal(firstPrice);
      const calculatedServices = Number(
        ((locationState?.commission / 100) * (firstPrice + extraTotal + (isValid ? cleaning_costs : 0))).toFixed(2)
      );
      const calculatedTva = Number((0.2 * calculatedServices).toFixed(2));
      const calculatedTotal = Number(
        (calculatedServices + firstPrice + extraTotal + (isValid ? cleaning_costs : 0)).toFixed(2)
      );
      setServices(calculatedServices);
      setTva(calculatedTva);
      setTotal(calculatedTotal);
    } else {
      setServices(0);
      setTotal(0);
    }
  };

  useEffect(() => {
    if (selectedDay) {
      setSelectedPriceId("");
      setPrice(null);
      setPriceId("");
      setVisitorRange(undefined);
      setAvailableHoursState([]);
      // On réinitialise le choix de départ et de durée
      setSelectedStartHour(null);
      setSelectedDuration(null);
    }
  }, [selectedDay]);

  const handleStartHourChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedHour = parseInt(event.target.value);
    setSelectedStartHour(selectedHour);

    setMaxDuration(parseInt(locationState?.nbreHour || "1"));
    setPeriode(parseInt(locationState?.nbreHour || "1"));
    const { maxConsecutiveHours } = findMaxConsecutiveHours(
      availableHoursState,
      selectedStartHour!,
      parseInt(locationState.nbreHour)
    );
    setMaxDuration(maxConsecutiveHours);
    if (maxConsecutiveHours + 1 < parseInt(locationState?.nbreHour)) {
      setShowModal(true);
    }

    handleTotalChange(parseInt(locationState?.nbreHour));
  };

  const [selectedHourRange, setSelectedHourRange] = useState<string>("");
  const handleStartHourChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedHourRange = event.target.value;
    setSelectedHourRange(selectedHourRange);
    if (typeof selectedHourRange === "string" && selectedHourRange.includes("-")) {
      const formatTime = (time: string) => {
        const hour = time.padStart(2, "0");
        const minute = "00";
        return `${hour}:${minute}`;
      };

      const [startHour, endHour] = selectedHourRange.split("-");
      const formattedStartHour = formatTime(startHour);
      const formattedEndHour = formatTime(endHour);

      setSelectedStartHour(formattedStartHour);
      setSelectedEndHour(formattedEndHour);
    } else {
      setSelectedStartHour(null);
      setSelectedEndHour(null);
    }
  };

  const handleEventTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const evnt = event.target.value;
    setSelectedEvent(evnt);
  };

  useEffect(() => {
    if (selectedEvent) {
      handleTotalChange(parseInt(locationState?.nbreHour || "0"));
    }
  }, [selectedEvent]);

  useEffect(() => {}, [selectedDay]);

  const findMaxConsecutiveHours = (
    availableSlots: { start: number; durations: number[] }[],
    selectedHour: number,
    minHours: number
  ) => {
    // 1) Chercher l’objet dont start === selectedHour
    const slot = availableSlots.find((s) => s.start === selectedHour);

    // 2) si on ne trouve pas, on retourne simplement le minHours
    if (!slot) {
      return { maxConsecutiveHours: minHours };
    }

    // 3) dans slot.durations, la dernière entrée est la durée maximale
    //    (on suppose que durations est trié en ordre croissant, ex. [4,5,6])
    const lastIndex = slot.durations.length - 1;
    let maxConsecutive = slot.durations[lastIndex];

    // 4) on s’assure que le résultat ne soit jamais inférieur à minHours
    maxConsecutive = Math.max(maxConsecutive, minHours);

    return { maxConsecutiveHours: maxConsecutive };
  };

  const handleChangeDuration = (duration: number) => {
    setPeriode(duration);
  };

  const handleOpenModalImageGallery = () => {
    router(`${location.pathname}?gallery=images`);
  };

  const handleConversation = async () => {
    await dispatch(createConversation(parseInt(locationState?.Client?.userId)));
    navigate(`/client/messages`);
  };

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex items-center justify-between">
          <Badge
            name={
              <div className="flex items-center">
                <i className="text-sm las la-share-alt"></i>
                <span className="ml-1">{locationState && locationState?.CategoryLocation?.designation}</span>
              </div>
            }
          />
          <Badge
            name={
              <div className="flex items-center">
                <i className="las la-map-marker"></i>
                <span className="ml-1">{locationState?.city}</span>
              </div>
            }
            color="yellow"
          />
          <LikeSaveBtns onClick={handleClickLike} isFavorited={!isLiked} share={handleShareButtonClick} />
        </div>

        <AlertModalMessage
          open={showModal}
          handleClose={() => setShowModal(false)}
          message={`Veuillez noter que la réservation nécessite au moins 2 heures.`}
          alertText="Important"
        />
        <AlertModalMessage
          open={showModalExistReservation}
          handleClose={() => setShowModalExistReservation(false)}
          message={`Il semble qu'il y ait déjà une réservation pour cette période.`}
          alertText="Oups !"
        />
        {/* 2 */}
        <h2 className="text-2xl font-semibold sm:text-3xl lg:text-4xl">{locationState?.title}</h2>

        {/* 3 */}
        <div className="flex items-center space-x-4">
          <StartRating point={locationState?.averageLikes} reviewCount={locationState?.commentCount} />
          <span>·</span>
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1">
              {" "}
              {/* {locationState?.address}, {locationState?.address2} */}
              {locationState?.city}, {locationState?.codePostale}
              {location.search !== "" && (
                <>
                  , {locationState?.address} {locationState?.address2}
                </>
              )}
            </span>
          </span>
        </div>

        {/* 4 */}
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <a href={`/owners/${locationState?.Client?.id}`}>
              <Avatar
                hasChecked
                sizeClass="h-10 w-10"
                radius="rounded-full"
                imgUrl={
                  locationState?.Client?.client_url
                    ? process.env.REACT_APP_CLOUD_FRONT + locationState?.Client?.client_url
                    : ""
                }
              />
            </a>
            <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
              Publié par :{" "}
              <span className="font-medium text-neutral-900 dark:text-neutral-200">
                <span>{locationState?.Client?.name}</span>
              </span>
            </span>
          </div>
        </div>

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        <div className="flex flex-col space-y-4 text-sm text-neutral-700 dark:text-neutral-300 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:space-x-8 xl:flex-row xl:items-center xl:justify-start xl:space-x-12">
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-expand"></i>
            <span className="">
              <span className="">Superficie</span> {locationState?.surface} m²
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-user"></i>
            <span className="">
              <span className="">Capacité d'accueil</span> {locationState?.visitor}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-clock"></i>
            <span className="">
              {String(locationState?.minStartHour).padStart(2, "0")}:00 -{" "}
              {String(locationState?.maxEndHour).padStart(2, "0")}:00
            </span>
          </div>
          {locationState?.handicap !== false && (
            <div className="flex items-center space-x-3">
              <i className="text-2xl lab la-accessible-icon"></i>
              <span className="">Accessible </span>
            </div>
          )}
        </div>
        <div className="flex flex-col space-y-4 text-sm text-neutral-700 dark:text-neutral-300 sm:flex-row sm:items-center sm:justify-between sm:space-y-0 sm:space-x-8 xl:flex-row xl:items-center xl:justify-start xl:space-x-12">
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-toilet"></i>
            <span className="">WC {locationState?.wc}</span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="text-2xl las la-parking"></i>
            <span className="">
              Parking {locationState?.parking} <span className="hidden sm:inline-block"></span>
            </span>
          </div>
          {locationState?.water && (
            <div className="flex items-center space-x-3">
              <i className="text-2xl las la-shower"></i>
              <span className="">Point d'eau </span>
            </div>
          )}
          {locationState?.light && (
            <div className="flex items-center space-x-3">
              <i className="text-2xl las la-lightbulb"></i>
              <span className="">Eclairage nocturne </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    const desc = locationState?.description.slice(0, 675);
    const allDesc = locationState?.description;
    const handleClickVoirPlus = () => {
      setAllDesc(false);
    };
    const handleClickVoirMoins = () => {
      setAllDesc(true);
    };

    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Description</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>

        <div className="flex flex-wrap items-center gap-2">
          {locationState.atmosphere.length > 0 &&
            locationState?.atmosphere.map((item: any, index: number) => (
              <div key={index} className="flex items-center space-x-1">
                <div className=""></div>
                <Badge href="##" color="purple" name={item} />
              </div>
            ))}
        </div>

        <div className="text-neutral-6000 dark:text-neutral-300">
          <TextDisplay text={allDescs ? desc : locationState?.description} />
          {/* <span>{allDescs ? desc : locationState?.description}</span> */}
          {locationState?.description.length >= 675 && allDescs && (
            <span className="text-sm text-blue-500 cursor-pointer hover:underline" onClick={handleClickVoirPlus}>
              {" "}
              Voir plus
            </span>
          )}

          {allDesc && allDescs === false && (
            <span className="text-sm text-blue-500 cursor-pointer hover:underline" onClick={handleClickVoirMoins}>
              {" "}
              Voir moins
            </span>
          )}
        </div>
      </div>
    );
  };

  const RenderSection = ({
    title,
    items,
    iconClass,
    renderItem,
  }: {
    title: string;
    items: any[];
    iconClass: string;
    renderItem: (item: any) => React.ReactNode;
  }) => (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{title}</h2>
      </div>
      <div className="grid grid-cols-1 gap-6 text-sm xl:grid-cols-3 text-neutral-700 dark:text-neutral-300">
        {items?.map((item: any, index: number) => (
          <div key={index} className="flex items-center space-x-3">
            <i className={`text-2xl ${iconClass}`}></i>
            <span>{renderItem(item)}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const RenderSection2 = ({
    title,
    items,
    iconClass,
    renderItem,
  }: {
    title: string;
    items: any[];
    iconClass: string;
    renderItem: (item: any) => React.ReactNode;
  }) => (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{title}</h2>
      </div>
      <div className="grid grid-rows-1 gap-6 text-sm xl:grid-rows-3 text-neutral-700 dark:text-neutral-300">
        {items?.map((item: any, index: number) => (
          <div key={index} className="flex items-center space-x-3">
            <i className={`text-2xl ${iconClass}`}></i>
            <span>{renderItem(item)}</span>
          </div>
        ))}
      </div>
    </div>
  );

  // Section 3 - Equipment
  const renderSection3 = () => (
    <RenderSection
      title="Équipements Disponibles"
      items={locationState?.equipments}
      iconClass="las la-check"
      renderItem={(item: any) => item?.equipment}
    />
  );

  // Events Section
  const renderEventsSection = () => (
    <RenderSection
      title="Événements"
      items={locationState?.events}
      iconClass="las la-handshake"
      renderItem={(item: any) => item}
    />
  );

  // Playground Section
  const renderPlayGroundsSection = () => (
    <RenderSection
      title="Aire de jeux"
      items={locationState?.playground}
      iconClass="las la-dice"
      renderItem={(item: any) => item}
    />
  );

  // Condition Section
  const renderSection9 = () => (
    <RenderSection2
      title="Les règles de cet espace"
      items={locationState.conditions}
      iconClass="las la-exclamation-triangle"
      renderItem={(item: any) => item?.designation}
    />
  );

  const renderSection10 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Extra équipements</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <div className="">
            {locationState?.extras &&
              !reservation &&
              locationState?.extras?.map((item: any, index: number) => (
                <div key={index} className="flex items-center justify-between mt-3">
                  {String(locationState.Client.id) !== String(authContext.user?.profil?.id) ? (
                    <CheckboxInput
                      name={item.designation}
                      key={item.designation}
                      label={`${
                        item.price !== 0 ? `${item.designation}: ${item.price} €` : `${item.designation}: Gratuit`
                      }`}
                      onChange={(e) => handleExtraCheckboxChange(item, e.checked)}
                      checked={
                        item &&
                        checkedExtra.some(
                          (checkedItem) =>
                            checkedItem.designation === item.designation && checkedItem.price === item.price
                        )
                      }
                    />
                  ) : (
                    <div key={item.designation} className="flex items-center space-x-3">
                      <i className="text-2xl las la-check"></i>
                      <span className="">
                        {item.price !== 0
                          ? `${item.designation}: ${item.price} €`
                          : `${item.designation}: Gratuit`}
                      </span>
                    </div>
                  )}

                  {String(locationState.Client.id) !== String(authContext.user?.profil?.id) && (
                    <div className="">
                      <NcInputNumberOne
                        onChange={(value) => handleChangeData(item, value)} // ← Changement ici : passer 'item' au lieu de 'index'
                        defaultValue={
                          // Récupérer la quantité actuelle depuis checkedExtra
                          checkedExtra.find(
                            (checkedItem) =>
                              checkedItem.designation === item.designation &&
                              checkedItem.price === item.price &&
                              checkedItem.priceId === item.priceId
                          )?.qte || 1
                        }
                        min={1}
                        max={item.quantity}
                        disabled={
                          !checkedExtra.some(
                            (checkedItem) =>
                              checkedItem.designation === item.designation &&
                              checkedItem.price === item.price &&
                              checkedItem.isChecked === true
                          )
                        }
                      />
                    </div>
                  )}
                </div>
              ))}
            <div className="grid grid-cols-1 gap-6 text-sm xl:grid-cols-3 text-neutral-700 dark:text-neutral-300">
              {locationState?.extras &&
                reservation &&
                locationState?.extras?.map((item: any, index: number) => (
                  <div key={index} className="flex items-center space-x-3">
                    <i className="text-2xl las la-plus"></i>
                    <span>{item.designation}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (ownerInView && locationState?.userId) {
      dispatch(getOwnerById(locationState?.userId));
    }
  }, [ownerInView, id, dispatch]);

  const renderSection5 = () => {
    if (!ownerState) {
      // Loading skeleton
      return (
        <div ref={ownerRef} className="listingSection__wrap animate-pulse">
          <h2 className="text-2xl font-semibold">Proposé par</h2>
          <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

          <div className="flex items-center space-x-4">
            <div className="rounded-full h-14 w-14 bg-neutral-200 dark:bg-neutral-700" />
            <div className="space-y-2">
              <div className="w-24 h-4 rounded bg-neutral-200 dark:bg-neutral-700" />
              <div className="w-32 h-3 rounded bg-neutral-200 dark:bg-neutral-700" />
            </div>
          </div>

          <div className="space-y-2.5 mt-4">
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded bg-neutral-200 dark:bg-neutral-700" />
              <div className="w-40 h-4 rounded bg-neutral-200 dark:bg-neutral-700" />
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-6 h-6 rounded bg-neutral-200 dark:bg-neutral-700" />
              <div className="w-32 h-4 rounded bg-neutral-200 dark:bg-neutral-700" />
            </div>
            <div className="w-48 h-10 rounded bg-neutral-200 dark:bg-neutral-700" />
          </div>
        </div>
      );
    }

    return (
      <div ref={ownerRef} className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Proposé par</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

        {/* host */}
        <div className="flex items-center space-x-4">
          <a href={`/owners/${ownerState?.id}`} aria-label={`Visit ${ownerState?.name}'s profile`}>
            <Avatar
              hasChecked
              hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
              sizeClass="h-14 w-14"
              radius="rounded-full"
              imgUrl={
                ownerState?.client_url ? `${process.env.REACT_APP_CLOUD_FRONT}${ownerState.client_url}` : undefined
              }
            />
          </a>
          <div>
            <span className="block font-medium">{ownerState?.name || "N/A"}</span>
            <div className="mt-1.5 flex items-center text-sm text-neutral-500 dark:text-neutral-400">
              <StartRating point={ownerState?.overallAverageLikes ?? 0} />
              <span className="mx-2">·</span>
              <span>{ownerState?.totalLocations ?? 0} Espaces</span>
            </div>
          </div>
        </div>

        {/* info */}
        <div className="block space-y-2.5 text-neutral-500 dark:text-neutral-400">
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span>
              Inscrit le{" "}
              {ownerState?.createdAt ? new Date(ownerState.createdAt).toLocaleDateString("fr-FR") : "N/A"}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
            <span>Temps de réponse - 100%</span>
          </div>

          {String(locationState?.Client?.id) !== String(authContext.user?.profil?.id) &&
            ownerState?.sendMessage && (
              <div className="mt-1">
                <ButtonPrimary type="button" onClick={handleConversation} aria-label="Envoyer un message à l'hôte">
                  Envoyer un message à l'hôte
                </ButtonPrimary>
              </div>
            )}
        </div>

        {/* divider */}
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

        {/* view profile */}
        <div className="w-1/2">
          {String(locationState?.Owner?.id) !== String(authContext.user?.profil?.id) && (
            <ButtonSecondary href={`/owners/${locationState?.Client?.id}`}>Voir le profil</ButtonSecondary>
          )}
        </div>
      </div>
    );
  };
  const PriceListSection: React.FC<any> = ({ availability = [], prices = [] }) => {
    const [expandedDay, setExpandedDay] = useState<string | null>(null);

    // Grouper les prix par jour
    const groupedPrices = prices.reduce((acc: Record<string, any[]>, price: any) => {
      if (!acc[price.day]) acc[price.day] = [];
      acc[price.day].push(price);
      return acc;
    }, {});

    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Disponibilités et tarifs</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>

        {/* Liste des jours disponibles */}
        <div className="mt-4">
          {availability.map((day: string) => (
            <div key={day} className="mb-4">
              <div
                className="flex items-center justify-between p-3 rounded-lg cursor-pointer bg-neutral-100 dark:bg-neutral-800"
                onClick={() => setExpandedDay(expandedDay === day ? null : day)}
              >
                <span className="font-medium">{day}</span>
                <button className="text-blue-500">
                  {expandedDay === day ? (
                    <div>
                      Fermer <i className=" las la-angle-down"></i>
                    </div>
                  ) : (
                    <div>
                      Détails <i className="las la-angle-right"></i>
                    </div>
                  )}
                </button>
              </div>

              {/* Liste des prix (visible quand le jour est ouvert) */}
              {expandedDay === day && groupedPrices[day] && (
                <div className="pl-4 mt-2 space-y-2">
                  {groupedPrices[day]
                    .sort((a: any, b: any) => {
                      // Define order of types
                      const typeOrder: Record<string, number> = {
                        heure: 1,
                        soirée: 2,
                        "demi-journée": 3,
                        "journée complète": 4,
                      };

                      // First, sort by type priority
                      if (typeOrder[a.type] !== typeOrder[b.type]) {
                        return typeOrder[a.type] - typeOrder[b.type];
                      }

                      // If types are the same, sort by startHour
                      return parseInt(a.startHour) - parseInt(b.startHour);
                    })
                    .map((price: any) => (
                      <div
                        key={price.id}
                        className="flex items-center justify-between p-4 transition-shadow duration-300 bg-white border shadow-sm dark:bg-neutral-800 rounded-xl hover:shadow-md border-neutral-200 dark:border-neutral-700"
                      >
                        <div className="flex items-center space-x-3 text-sm font-medium text-neutral-700 dark:text-neutral-200">
                          <div className="flex items-center space-x-2">
                            <Clock className="w-4 h-4 text-eventToBee dark:text-indigo-400" aria-hidden="true" />
                            <span>
                              {price.startHour} - {price.endHour}
                            </span>
                          </div>
                          <span className="mx-2 text-neutral-400 dark:text-neutral-500">/</span>
                          <div className="flex items-center space-x-2">
                            <Users className="w-4 h-4 text-eventToBee dark:text-indigo-400" aria-hidden="true" />
                            <span>
                              {price.min} - {price.max}
                            </span>
                          </div>
                        </div>
                        <div className="text-sm font-semibold text-neutral-800 dark:text-neutral-100">
                          <span className="text-eventToBee dark:text-indigo-400">{price.price} €</span> /{" "}
                          <span className="capitalize">
                            {price.type === "heure"
                              ? "heure"
                              : price.type === "demi-journée"
                                ? "demi-journée"
                                : price.type === "journée complète"
                                  ? "journée complète"
                                  : "soirée"}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderSection4 = () => {
    const availability = locationState?.availableDays || [];
    const prices = locationState?.prices || [];
    return <PriceListSection availability={availability} prices={prices} />;
  };

  useScrollToHash("#commentaires", "commentaire");

  useEffect(() => {
    if (commentsInView && id) {
      dispatch(fetchCommentById(id));
    }
  }, [commentsInView, id, dispatch]);

  const renderSection6 = () => {
    return (
      <div id="commentaire" ref={commentsRef} className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Avis ({commentStates?.totalComments})</h2>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>
        {commentsInView ? (
          <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
            {commentStates?.comments
              .slice(0, showAllComments ? commentStates.comments.length : 5)
              .map((comment: any) => <CommentListing key={comment.id} data={comment} className="py-8" />)}
            {commentStates?.totalComments > 5 && (
              <ButtonSecondary onClick={() => setShowAllComments(!showAllComments)}>
                {showAllComments ? "Cacher les avis" : "Voir plus d'avis"}
              </ButtonSecondary>
            )}
          </div>
        ) : (
          <div>Loading comments...</div>
        )}
      </div>
    );
  };

  const renderSection7 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Localisation</h2>
        </div>
        <div className="border-b w-14 border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
        <div className="z-0 rounded-xl ring-1 aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-black/10">
          <div className="z-0 overflow-hidden rounded-xl">
            {lat && lng && (
              <iframe
                title="x"
                width="100%"
                height="100%"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={googleMapsURL}
              ></iframe>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div className="flex justify-between">
          <h2 className="text-2xl font-semibold">Informations suplémentaires</h2>
        </div>
        {/* CONTENT */}

        <span className="block text-neutral-500 dark:text-neutral-400">
          - Dêpot de garantie : {locationState?.guarantee} € <br />
        </span>
        <span className="block text-neutral-500 dark:text-neutral-400">
          - Frais de ménage : {locationState?.cleaning_costs} € <br />
        </span>
      </div>
    );
  };

  const renderSection11 = () => {
    return (
      <div className=" listingSection__wrap">
        {/* HEADING */}
        <div className="flex justify-between ">
          <h2 className="text-2xl font-semibold">Politiques d'annulation</h2>
        </div>
        {/* CONTENT */}
        {locationState?.reservation_type === "Stricte" ? (
          <>
            <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
              <p>
                {" "}
                Stricte : Les clients peuvent annuler dans les 48 heures suivant la réservation pour un
                remboursement complet. Passé ce délai, aucune annulation n'est possible et aucun remboursement ne
                sera effectué.
              </p>

              <p>- Remboursement de 70 % de la valeur de la réservation en cas d'annulation </p>
            </span>
          </>
        ) : (
          <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
            <p>
              {" "}
              Flexible : Les clients peuvent annuler jusqu'à 5 jours avant la date d'arrivée prévue pour un
              remboursement de 70 % du montant total. Les annulations effectuées moins de 5 jours avant la date
              d'arrivée ne sont pas remboursables.
            </p>
          </span>
        )}
        <div></div>
      </div>
    );
  };

  const renderSidebar = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks

    return (
      <div id="renderSidebar" className="shadow-xl listingSectionSidebar__wrap">
        {/* PRICE */}

        <div
          className={`flex ${locationState?.availabilityList.length === 1 ? "justify-center" : "justify-between"}`}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="time selection"
            sx={(theme) => ({
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 500,
                color: theme.palette.mode === "dark" ? "#ffff" : "#6b7280",
                "&.Mui-selected": {
                  color: theme.palette.mode === "dark" ? "#ffffff" : "#2563eb",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#2563eb",
              },
            })}
          >
            {locationState?.availabilityList.map(({ label, value }: { label: any; value: any }) => (
              <Tab key={value} value={value} label={label} />
            ))}
          </Tabs>
        </div>
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            {price ? <>{price} €</> : <>{location_minPrice} €</>}
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              {value ? <>/{value} </> : <>/{locationState && locationState.minPriceType} </>}
            </span>
          </span>
        </div>

        <div className="flex justify-center font-semibold text-center">
          <span>Quand souhaitez-vous reserver ?</span>
        </div>
        <form className="flex flex-col">
          <StayDatesRangeInput
            className="flex-1 z-[11] border-2 rounded-lg "
            availableDays={availableDays}
            onTotalDayChange={handleSelectedDayChange}
            fullyDays={fullyDaysState.map((day: { date: string }) => day.date)}
            unavailableDays={unavailableState}
            onClick={handleAvailibility}
            value={value}
          />
          <br />
          {Submit && value !== "journée complète" && (
            <div className="flex items-center justify-center">
              <BookingLoader />
            </div>
          )}
          {!Submit &&
            selectedDay &&
            locationState.cleaning_costs !== 0 &&
            locationState?.cleaning_costs_events.length !== 0 && (
              <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
                <FormItem label="Type d'événement" desc="">
                  <Select onChange={handleEventTypeChange} disabled={!selectedDay} value={selectedEvent || ""}>
                    <option value="" disabled>
                      Sélectionnez un événement
                    </option>
                    {Array.isArray(locationState?.events) &&
                      locationState?.events.map((item: any) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                  </Select>
                </FormItem>
              </motion.div>
            )}
          {!Submit && value === "heure" && selectedDay && (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              {/* === Champ “Heure d’entrée” === */}
              <FormItem label="Heure d'entrée" desc="">
                <Select
                  onChange={handleStartHourChange}
                  title={selectedDay ? "Sélectionnez une heure d'entrée" : "Veuillez ajouter le jour souhaité."}
                  disabled={!selectedDay || !availableHoursState.length}
                  value={selectedStartHour ?? ""}
                >
                  {!selectedDay && (
                    <option value="" disabled>
                      Veuillez d'abord sélectionner une date
                    </option>
                  )}
                  {selectedDay && !availableHoursState.length && (
                    <option value="" disabled>
                      Aucune heure disponible
                    </option>
                  )}
                  {selectedDay && availableHoursState.length > 0 && (
                    <option value="" disabled>
                      Sélectionnez une heure
                    </option>
                  )}

                  {/* On boucle sur availableHoursState pour n’afficher que les starts valides */}

                  {(() => {
                    if (!availableHoursState.length) return null;

                    // Extract the smallest and largest start hour from available slots
                    const startHour = Math.min(...availableHoursState.map((slot) => slot.start));
                    const lastStartHour = Math.max(...availableHoursState.map((slot) => slot.start));
                    const nbreHour = parseInt(locationState?.nbreHour);
                    const disableFromHour = lastStartHour + nbreHour;

                    // We'll go from the earliest to the last possible hour (inclusive)
                    const endHour = disableFromHour; // This ensures we also render disabled hours after the last slot
                    const totalHours = endHour - startHour + 1;

                    return Array.from({ length: totalHours }, (_, i) => i + startHour).map((hour) => {
                      const isAvailable = availableHoursState.some((slot) => slot.start === hour);
                      const shouldDisable = hour >= disableFromHour || !isAvailable;

                      return (
                        <option key={hour} value={hour} disabled={shouldDisable}>
                          {`${hour}:00`}
                        </option>
                      );
                    });
                  })()}
                </Select>
              </FormItem>
            </motion.div>
          )}
          {!Submit && (value === "demi-journée" || value === "soirée") && selectedDay && (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <FormItem label="Heure d'entrée" desc="">
                <Select
                  onChange={handleStartHourChange2}
                  title={selectedDay ? "Sélectionnez une heure d'entrée" : "Veuillez ajouter le jour souhaité."}
                  disabled={!selectedDay || !availableHoursState.length}
                  value={selectedHourRange}
                >
                  {!selectedDay && (
                    <option value="" disabled>
                      Veuillez d'abord sélectionner une date
                    </option>
                  )}
                  {selectedDay && !availableHoursState.length && (
                    <option value="" disabled>
                      Aucune plage horaire disponible
                    </option>
                  )}
                  {selectedDay && availableHoursState.length > 0 && (
                    <option value="" disabled>
                      Sélectionnez une plage horaire
                    </option>
                  )}
                  {selectedDay &&
                    availableHoursState.length > 0 &&
                    availableHoursState.map((hour: any, index: number) => (
                      <option
                        key={index}
                        value={
                          typeof hour === "string"
                            ? hour
                            : `${hour.start}-${hour.start + hour.durations[hour.durations.length - 1]}`
                        }
                      >
                        {typeof hour === "string"
                          ? hour
                          : `${hour.start}:00-${hour.start + hour.durations[hour.durations.length - 1]}:00`}
                      </option>
                    ))}
                </Select>
              </FormItem>
            </motion.div>
          )}
          {selectedDay && (value === "demi-journée" || value === "soirée") && selectedHourRange ? (
            <motion.div
              variants={formItemVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              className="mt-2"
            >
              <FormItem label="Visiteurs">
                <Select onChange={handleChangePrice} value={selectedPriceId}>
                  <option value="Nombre de visiteurs">Nombre de visiteurs</option>

                  {selectedStartHour !== null && selectedEndHour !== null ? (
                    (() => {
                      const formatTime = (time: string) => {
                        const hour = time.padStart(2, "0");
                        const minute = "00";
                        return `${hour}:${minute}`;
                      };

                      const dayMapping: { [key: string]: string } = {
                        Mon: "Lundi",
                        Tue: "Mardi",
                        Wed: "Mercredi",
                        Thu: "Jeudi",
                        Fri: "Vendredi",
                        Sat: "Samedi",
                        Sun: "Dimanche",
                      };

                      let selectedDayFrench = "Samedi";
                      if (selectedDay) {
                        const selectedDayEnglish = new Date(selectedDay).toString().split(" ")[0];
                        selectedDayFrench = dayMapping[selectedDayEnglish] || selectedDayFrench;
                      }

                      const filteredPrices = locationState?.prices?.filter((price: any) => {
                        const formattedStartHour = formatTime(price.startHour);
                        const formattedEndHour = formatTime(price.endHour);
                        const formattedSelectedStart = formatTime(selectedStartHour);
                        const formattedSelectedEnd = formatTime(selectedEndHour);

                        return (
                          formattedStartHour === formattedSelectedStart &&
                          formattedEndHour === formattedSelectedEnd &&
                          price.day === selectedDayFrench
                        );
                      });

                      return filteredPrices.length > 0 ? (
                        filteredPrices.map((price: any) => (
                          <option key={price.id} value={price.id}>
                            {price.min && price.max ? `${price.min}-${price.max}` : "N/A"}
                          </option>
                        ))
                      ) : (
                        <option disabled>Aucuns prix disponibles</option>
                      );
                    })()
                  ) : (
                    <option disabled>Veuillez d'abord sélectionner une plage horaire</option>
                  )}
                </Select>
              </FormItem>
            </motion.div>
          ) : null}
          {value === "journée complète" && selectedDay && (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <FormItem label="Visiteurs">
                <Select onChange={handleChangePrice} value={selectedPriceId}>
                  <option value="Nombre de visiteurs">Nombre de visiteurs</option>

                  {(() => {
                    const dayMapping: { [key: string]: string } = {
                      Mon: "Lundi",
                      Tue: "Mardi",
                      Wed: "Mercredi",
                      Thu: "Jeudi",
                      Fri: "Vendredi",
                      Sat: "Samedi",
                      Sun: "Dimanche",
                    };

                    let selectedDayFrench = "Samedi";
                    if (selectedDay) {
                      const selectedDayEnglish = new Date(selectedDay).toString().split(" ")[0];
                      selectedDayFrench = dayMapping[selectedDayEnglish] || selectedDayFrench;
                    }

                    const filteredPrices = locationState?.prices?.filter((price: any) => {
                      return price.type === value && price.day === selectedDayFrench;
                    });

                    return filteredPrices?.length > 0 ? (
                      filteredPrices.map((price: any) => (
                        <option key={price.id} value={price.id}>
                          {price.min && price.max ? `${price.min}-${price.max}` : "N/A"}
                        </option>
                      ))
                    ) : (
                      <option disabled>No prices available</option>
                    );
                  })()}
                </Select>
              </FormItem>
            </motion.div>
          )}
          {value === "heure" && selectedStartHour && (
            <motion.div
              variants={formItemVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              className="mt-2"
            >
              <FormItem label="Visiteurs">
                <Select onChange={handleChangePrice} value={selectedPriceId}>
                  <option value="" disabled>
                    Nombre de visiteurs
                  </option>

                  {selectedStartHour !== null ? (
                    (() => {
                      const dayMapping: { [key: string]: string } = {
                        Mon: "Lundi",
                        Tue: "Mardi",
                        Wed: "Mercredi",
                        Thu: "Jeudi",
                        Fri: "Vendredi",
                        Sat: "Samedi",
                        Sun: "Dimanche",
                      };

                      const selectedDayFrench = selectedDay
                        ? dayMapping[new Date(selectedDay).toString().split(" ")[0]] || "Samedi"
                        : "Samedi";

                      const filteredPrices = (locationState?.prices || []).filter((price: any) => {
                        return price.day === selectedDayFrench && price.type === "heure";
                      });

                      return filteredPrices.length > 0 ? (
                        filteredPrices.map((price: any) => (
                          <option key={price.id} value={price.id}>
                            {price.min && price.max ? `${price.min}-${price.max}` : "N/A"}
                          </option>
                        ))
                      ) : (
                        <option disabled>Aucun prix disponible</option>
                      );
                    })()
                  ) : (
                    <option disabled>Veuillez d'abord sélectionner une heure</option>
                  )}
                </Select>
              </FormItem>
            </motion.div>
          )}

          {value === "heure" && selectedDay && selectedStartHour && visitorRange ? (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <NcInputNumber
                className="w-full mt-6"
                defaultValue={periode}
                onChange={(value) => handleChangeDuration(value)}
                max={maxDuration}
                min={parseInt(locationState?.nbreHour || "1")}
                label="Durée"
              />
            </motion.div>
          ) : priceId && (value === "demi-journée" || value === "soirée") && selectedHourRange && visitorRange ? (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <div className="flex justify-between mt-6">
                <div>{value === "demi-journée" ? "Demi-journée" : "Soirée"}</div>

                <div>
                  {" "}
                  {priceStartHour} - {priceEndHour}
                </div>
              </div>
            </motion.div>
          ) : priceId && value === "journée complète" && selectedDay ? (
            <motion.div variants={formItemVariants} initial="hidden" animate="visible" exit="hidden">
              <div className="flex justify-between mt-6">
                <div>Journée complète :</div>
                <div>
                  {" "}
                  {priceStartHour} - {priceEndHour}
                </div>
              </div>
            </motion.div>
          ) : (
            ""
          )}

          <div className="w-full mt-2 border-b border-neutral-200 dark:border-neutral-700"></div>
          <br />
          <div className="flex justify-center font-semibold text-center">
            <span>Détails</span>
          </div>
          {/* SUM */}

          <div className="flex flex-col space-y-4">
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span>Sous-total </span>
              <span> {halfTotal} €</span>
            </div>

            {extraTotal && extraTotal !== 0 ? (
              <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                <span>Extra équipements</span>
                <span>{extraTotal} €</span>
              </div>
            ) : null}

            {selectedEvent && isCleaningCosts ? (
              <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                <span>Frais de ménage </span>
                <span>{locationState.cleaning_costs} €</span>
              </div>
            ) : null}

            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span className="flex items-center">
                Frais de service
                <div className="relative ml-2 group">
                  <svg
                    className="w-4 h-4 text-neutral-500 dark:text-neutral-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M12 3a9 9 0 100 18 9 9 0 000-18z"
                    ></path>
                  </svg>
                  <span className="absolute hidden px-2 py-1 mb-2 text-xs text-white -translate-x-1/2 rounded left-1/2 bottom-full group-hover:block bg-neutral-800 dark:bg-neutral-700 whitespace-nowrap">
                    TVA incluse
                  </span>
                </div>
              </span>
              <span> {services} €</span>
            </div>

            <div className="flex justify-between font-semibold">
              <span>Total</span>
              <span>{total} €</span>
            </div>
          </div>
          {/* SUBMIT */}
          <ButtonPrimary
            className="mt-5"
            type="button"
            loading={isLoadingSubmit}
            onClick={handleSubmit}
            disabled={!selectedDay || !price}
          >
            Demande de réservation
          </ButtonPrimary>
        </form>
      </div>
    );
  };

  const renderSidebar2 = () => {
    return (
      <motion.div
        id="renderSidebar"
        className="w-full p-6 bg-white shadow-lg dark:bg-neutral-800 rounded-2xl listingSectionSidebarInactive__wrap"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        {/* PRICE */}
        <div className="">
          <div className="flex items-center ">
            <div>
              <p className="text-sm font-normal text-start text-neutral-500 dark:text-neutral-400">
                Intéressé par cet espace ? Contactez l’hôte pour
              </p>
              <p className="text-sm font-normal text-start text-neutral-500 dark:text-neutral-400">
                plus d’informations ou pour organiser une visite.
              </p>
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <form>
              <ButtonPrimary
                className="px-5 py-3 text-white transition-colors bg-blue-600 hover:bg-blue-700"
                type="button"
                loading={isLoadingSubmit}
                onClick={handleContact}
              >
                Contactez l'hôte
              </ButtonPrimary>
            </form>
          </div>
        </div>
      </motion.div>
    );
  };

  const renderSimilarLocations = ({
    locationState,
    relatedLocations,
    glideRef,
    renderPostRelated,
  }: {
    locationState: any;
    relatedLocations: any;
    glideRef: any;
    renderPostRelated: any;
  }) => {
    return (
      locationState &&
      relatedLocations?.length >= 4 && (
        <div className="relative py-16 mt-16 bg-neutral-100 dark:bg-neutral-800 lg:py-28 lg:mt-24">
          <div className="container glide" ref={glideRef}>
            <h2 className="text-3xl font-semibold text-center">Découvrez d'autres espaces similaires</h2>
            <div
              className="grid gap-6 mt-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-8 glide__track"
              data-glide-el="track"
            >
              <div
                className="glide__slides"
                style={{
                  transition: "height: 4755px !important",
                }}
              >
                {Array.isArray(relatedLocations) && relatedLocations.map(renderPostRelated)}
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  const renderPostRelated = (location: any) => {
    return (
      <div key={location.id} className="flex overflow-hidden aspect-w-13 aspect-h-1 rounded-3xl group">
        <a href={`/location/${location.id}`} />
        <NcImage
          className="object-cover w-full h-full transition-transform duration-300 transform group-hover:scale-105"
          src={process.env.REACT_APP_CLOUD_FRONT + location.image}
        />
        <div>
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black"></div>
        </div>
        <div className="flex flex-col justify-end items-start text-xs text-neutral-300 space-y-2.5 p-4">
          <h2 className="block max-w-full text-lg font-semibold text-white">
            <span className="line-clamp-2">{location?.title}</span>
          </h2>
        </div>
        <a href={`/location/${location.id}`} />
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>{`Event To Bee - ${locationState?.title}`}</title>
        <meta
          name="description"
          content="Découvrez les détails du l'espace à louer pour votre évènement sur Event To Bee ."
        />
      </Helmet>

      {!loading ? (
        <DetailPagetLayout>
          <div className="mb-5 nc-ListingStayDetailPage">
            {/*  HEADER */}
            <header className="rounded-md sm:rounded-xl">
              <div className="relative grid grid-cols-3 gap-1 sm:grid-cols-4 sm:gap-2">
                <div
                  className="relative col-span-2 row-span-3 overflow-hidden rounded-md cursor-pointer sm:row-span-2 sm:rounded-xl"
                  onClick={handleOpenModalImageGallery}
                >
                  <img
                    className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-xl"
                    src={process.env.REACT_APP_CLOUD_FRONT + locationState?.images[0]}
                    alt=""
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                  />
                  <div className="absolute inset-0 transition-opacity opacity-0 bg-opacity-20 bg-neutral-900 hover:opacity-100"></div>
                </div>

                {locationState?.images.slice(0, 4).map((item: string, index: number) => (
                  <div key={index} className={`relative rounded-md sm:rounded-xl overflow-hidden`}>
                    <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
                      <img
                        className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-xl"
                        src={process.env.REACT_APP_CLOUD_FRONT + item}
                        alt=""
                        sizes="400px"
                      />
                    </div>

                    <div
                      className="absolute inset-0 transition-opacity opacity-0 cursor-pointer bg-opacity-20 bg-neutral-900 hover:opacity-100"
                      onClick={handleOpenModalImageGallery}
                    />
                  </div>
                ))}

                <button
                  className="absolute z-10 hidden px-4 py-2 bottom-3 left-3 rounded-xl md:flex md:items-center md:justify-center bg-neutral-100 text-neutral-500 hover:bg-neutral-200"
                  onClick={handleOpenModalImageGallery}
                >
                  <Squares2X2Icon className="w-5 h-5" />
                  <span className="ml-2 text-sm font-medium text-neutral-800">Afficher toutes les photos</span>
                </button>
              </div>
            </header>

            {/* MAIN */}
            <main className="relative z-10 flex flex-col mt-11 lg:flex-row">
              {/* CONTENT */}
              <div
                className={`space-y-8 w-full ${
                  String(locationState.Client.id) !== String(authContext.user?.profil?.id)
                    ? "lg:w-3/5 xl:w-2/3 lg:space-y-10 lg:pr-10"
                    : ""
                }`}
              >
                {renderSection1()}
                {renderSection2()}
                {locationState && locationState?.prices?.length > 0 && renderSection4()}
                {renderEventsSection()}
                {locationState.playground?.length > 0 && renderPlayGroundsSection()}

                {locationState?.equipments?.length > 0 && renderSection3()}
                {locationState?.extras?.length > 0 && renderSection10()}

                {locationState?.conditions?.length > 0 && renderSection9()}
                {renderSection5()}
                {renderSection6()}
                {renderSection7()}
                {renderSection8()}
                {renderSection11()}

                {showLoginModal && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black opacity-50"></div>

                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                      <div className="flex flex-col items-center p-6 bg-white rounded-lg dark:bg-neutral-900">
                        <div className="self-end mb-4">
                          <ButtonSecondary onClick={() => setShowLoginModal(false)}>X</ButtonSecondary>
                        </div>
                        <LoginModal LoginModal={(e) => setShowLoginModal(e)} />
                      </div>
                    </div>
                  </div>
                )}

                {showLastMinuteWarning && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center">
                    {/* Backdrop */}
                    <div className="absolute inset-0 bg-black opacity-50"></div>

                    {/* Dialog */}
                    <div className="relative z-10 max-w-md p-6 mx-auto space-y-4 text-yellow-800 bg-yellow-100 border border-yellow-400 rounded-md shadow-lg">
                      <p className="text-sm font-medium">
                        ⚠️ <strong>Attention : Demande de dernière minute</strong>
                      </p>
                      <p className="text-sm">
                        Vous êtes sur le point de réserver un espace pour un événement qui commence dans moins de
                        48 heures.
                        <br />
                        L’hôte dispose de 48 heures pour accepter ou refuser votre demande. Cependant, en raison de
                        la proximité de la date, il peut accepter à tout moment, y compris juste avant l’heure
                        prévue.
                        <br />
                        En validant votre demande, vous vous engagez à être prêt(e) à maintenir votre événement si
                        l’hôte accepte.
                      </p>

                      <div className="flex justify-end space-x-4">
                        <button
                          onClick={() => setShowLastMinuteWarning(false)}
                          className="px-4 py-2 text-sm text-gray-700 bg-white border rounded hover:bg-gray-100"
                        >
                          Annuler
                        </button>
                        <button
                          onClick={async () => {
                            setIsConfirmedLastMinute(true);
                            setShowLastMinuteWarning(false);
                            await handleSubmit(); // re-call with confirmation
                          }}
                          className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700"
                        >
                          Confirmer
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {contact && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black opacity-50"></div>

                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                      <div className="flex flex-col items-center p-6 bg-white rounded-lg dark:bg-neutral-900">
                        <ContactModal
                          open={contact}
                          handleClose={() => setContact(false)}
                          phone={authContext?.user?.profil?.phone}
                          alertText="Contactez l'hôte"
                          senderId={authContext?.user?.id}
                          receiverId={locationState?.Client?.userId}
                          showOwnerPhoneNumber={locationState?.Client?.User?.showPhoneNumber}
                          ownerPhoneNumber={locationState?.Client?.phone}
                          ownerEmail={locationState?.Client?.User?.email}
                          ownerFullName={
                            locationState?.Client?.companyName ||
                            locationState?.Client?.lastName + " " + locationState?.Client?.name
                          }
                          locationName={locationState?.title}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {showSocialMediaShare && <SocialMediaShare url={window.location.href} />}
              {!reservation && (
                <>
                  <div className="nc-ListingStayDetailPage">
                    {String(locationState.Client.id) === String(authContext.user?.profil?.id) ? (
                      <div className="fixed-sidebar"></div>
                    ) : String(locationState.Client.id) !== String(authContext.user?.profil?.id) &&
                      locationState?.Client?.User?.subscription_status === "inactive" ? (
                      <div className="fixed-sidebar">{renderSidebar()}</div>
                    ) : (
                      <div className="fixed-sidebar">{renderSidebar2()}</div>
                    )}
                    <br />
                  </div>
                </>
              )}
            </main>
          </div>

          <MobileFooterSticky price={price} minPrice={locationState ? Number(locationState?.minPrice) : 0} />
        </DetailPagetLayout>
      ) : (
        <>
          <div className="flex items-center justify-center h-screen">
            <DetailLoader icon={FaHome} />
          </div>
        </>
      )}
      {renderSimilarLocations({ locationState, relatedLocations, glideRef, renderPostRelated })}
    </>
  );
};

export default ListingStayDetailPage;
